import React, { Fragment, useEffect, useState } from "react";
import CaveatPicker from "../../sample_testing/CaveatPicker";
import Link from "../../Link";
import { post } from "../../../lib/Fetching";

export default function SampleCaveatsView({ sampleCaveats, sample_id, clientView, onChange }) {
  const deleteCaveat = (id) => {
    if (!confirm("Are you sure you want to delete this caveat?")) {
      return;
    }
    post("/sample_testing/sample_caveats/" + id, { sample_id }, "DELETE")
      .then((json) => {
        onChange();
      })
      .catch((error) => alert(error));
  };

  return (
    <div>
      <h4 style={{ marginTop: 0 }}>Sample Caveats</h4>
      {!clientView && (
        <p className="small">
          All sample caveats are displayed on the certificate of analysis
        </p>
      )}
      {sampleCaveats.length > 0 && (
        <table className="table table-condensed">
          <tr>
            <th>Caveat</th>
            <th style={{ width: 200 }}>Added By</th>
            <th style={{ width: 100 }}>Added At</th>
            <th style={{ width: 15 }}>&nbsp;</th>
          </tr>
          {sampleCaveats.map((sc) => (
            <tr>
              <td>{sc.caveat}</td>
              <td style={{ verticalAlign: "top" }}>{sc.added_by}</td>
              <td style={{ verticalAlign: "top" }}>{sc.created_at_f}</td>
              <td style={{ verticalAlign: "top" }}>
                &nbsp;
                <Link onClick={() => deleteCaveat(sc.id)}>
                  <i className="fa fa-trash" />
                </Link>
              </td>
            </tr>
          ))}
        </table>
      )}
      {!clientView && <CaveatPicker type="sample" ids={[sample_id]} onApply={onChange} />}
    </div>
  );
}
